const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/businessmag/list'], resolve),
  meta: {
    requireAuth: true
  }
}
export default list